import {BI_ORIGINS} from '@wix/wix-events-commons-statics'
import React from 'react'
import {useAppActions} from '../../../../../hooks/runtime'
import {AccessibilityMode} from '../../accessibility-mode'
import {TicketDescription} from '../../ticket-description'
import {Tickets} from '../../tickets'
import {SidebarProps} from './interfaces'
import s from './sidebar.scss'

export const Sidebar = ({
  showAccessibilityMode,
  onRemoveClick,
  onCheckoutClick,
  chooseSeatMode,
  chooseMultipleSeatsMode,
  placesInBasket,
  placesInBasketCount,
  setForcedPopoverPlanPlaceId,
  descriptionPlace,
  showSeatDescription,
  selectSeatForDescription,
  setAccessibilityToast,
}: SidebarProps) => {
  const {clickPlace} = useAppActions()

  return (
    <div className={s.sidebar}>
      <Tickets
        placesInBasketCount={placesInBasketCount}
        placesInBasket={placesInBasket}
        show={!showAccessibilityMode && !showSeatDescription}
        onRemoveClick={onRemoveClick}
        onCheckoutClick={onCheckoutClick}
        onTicketMoreInfoClick={selectSeatForDescription}
        chooseSeatMode={chooseSeatMode}
        chooseMultipleSeatsMode={chooseMultipleSeatsMode}
        setForcedPopoverPlanPlaceId={setForcedPopoverPlanPlaceId}
      />
      <AccessibilityMode
        setForcedPopoverPlanPlaceId={setForcedPopoverPlanPlaceId}
        setAccessibilityToast={setAccessibilityToast}
      />
      <TicketDescription
        showAccessibilityMode={showAccessibilityMode}
        onTicketClick={() =>
          clickPlace({
            place: descriptionPlace,
            origin: BI_ORIGINS.SEATINGS_MODAL_TICKET_DESCRIPTION,
            updateShownDescription: true,
          })
        }
        place={descriptionPlace}
        show={showSeatDescription}
        onClose={() => selectSeatForDescription(null)}
      />
    </div>
  )
}
